interface Answer {
  correct_answer: string;
  date_answered: string;
  display_order: number;
  is_correct: boolean;
  quiz_question_id: string;
  value: string;
}

interface Question {
  genre: string;
  html_question: string;
  id: string;
  options: object[];
  position: number;
  question: string;
  question_type: string;
  raw_question: object;
  updated_at: string;
}

// Ensure Quiz Summary answers/questions align based on quiz customization
// i.e. if student completes a quiz before/after questions are changed
const getAlignedQuizQuestionsAndAnswers = (
  isCustomQuiz: boolean,
  answers: Answer[],
  questions: Question[],
): { answers: Answer[]; questions: Question[] } => {
  let updatedAnswers = answers;
  let updatedQuestions = questions;

  if (isCustomQuiz || answers?.length !== questions?.length) {
    // First filter out answers based on custom quiz questions
    // in case the questions were reduced since student completed
    const currentQuestionIds = questions?.map((question) => question?.id);
    updatedAnswers = answers?.filter((answer) => {
      return currentQuestionIds?.includes(answer?.quiz_question_id);
    });

    // Then filter custom quiz questions based on answers
    // in case the questions were expanded since student completed
    const answerQuestionIds = updatedAnswers?.map(
      (answer) => answer?.quiz_question_id,
    );
    updatedQuestions = questions?.filter((question) => {
      return answerQuestionIds?.includes(question?.id);
    });
  }
  return { answers: updatedAnswers, questions: updatedQuestions };
};

export default getAlignedQuizQuestionsAndAnswers;
